import { render, staticRenderFns } from "./collection-controls.vue?vue&type=template&id=0b60b45a&scoped=true&"
import script from "./collection-controls.vue?vue&type=script&lang=js&"
export * from "./collection-controls.vue?vue&type=script&lang=js&"
import style0 from "./collection-controls.vue?vue&type=style&index=0&id=0b60b45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60b45a",
  null
  
)

export default component.exports